import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useChat } from '../contexts/ChatContext';
import ConversationTile from '../components/ConversationTile';

export default function HomeScreen() {
  const { user, logout } = useAuth();
  const { conversations, loading, currentUserId, loadConversations, getUser } = useChat();
  const navigate = useNavigate();

  useEffect(() => {
    loadConversations();
  }, []);

  const handleLogout = () => {
    logout();
    navigate('/login', { replace: true });
  };

  const getConvDisplayName = (conv) => {
    if (conv.isGroup) return conv.groupName || 'Group';
    const otherId = conv.participants.find((p) => p !== currentUserId);
    if (!otherId) return 'Unknown';
    const u = getUser(otherId);
    return u ? u.displayName || u.username : otherId.slice(0, 8);
  };

  const getOnlineStatus = (conv) => {
    if (conv.isGroup) return false;
    const otherId = conv.participants.find((p) => p !== currentUserId);
    if (!otherId) return false;
    const u = getUser(otherId);
    return u ? u.online : false;
  };

  return (
    <div className="home-screen">
      <div className="home-header">
        <div className="home-brand">
          <span className="brand-bee">🐝</span>
          <h1 className="home-title">BEETWEET</h1>
        </div>
        <div className="home-actions">
          <div className="home-avatar">
            {user?.displayName?.[0]?.toUpperCase() || user?.username?.[0]?.toUpperCase() || '?'}
          </div>
          <button className="logout-btn" onClick={handleLogout} title="Logout">
            ⏻
          </button>
        </div>
      </div>
      <div className="home-body">
        {loading && conversations.length === 0 ? (
          <div className="loading-center">
            <div className="spinner" />
          </div>
        ) : conversations.length === 0 ? (
          <div className="empty-state">
            No conversations yet.<br />Tap + to start a new chat.
          </div>
        ) : (
          <div className="conv-list">
            {conversations.map((conv) => (
              <ConversationTile
                key={conv._id}
                title={getConvDisplayName(conv)}
                lastMessage={conv.lastMessage?.content || ''}
                lastTime={conv.lastActivity}
                online={getOnlineStatus(conv)}
                onTap={() => navigate(`/chat/${conv._id}`, { state: { conversation: conv } })}
              />
            ))}
          </div>
        )}
      </div>
      <button className="fab" onClick={() => navigate('/new-chat')}>
        ✚
      </button>
    </div>
  );
}
